import { AxiosRequestConfig } from 'axios';

import Client from './client';
import { Journey } from './types';

type Response = {
  readonly result: 'SUCCESS' | 'ERROR';
  readonly status: number;
  readonly journey?: Journey;
  readonly journeys?: Journey[];
};

export default (userId: string, config?: AxiosRequestConfig) => {
  return Client.get<Response>(`/js/v1/user/${userId}/journey/current`, config);
};
